import moment from 'moment';
import random from 'lodash/random';
import cookie from 'react-cookie';
import concat from 'lodash/concat';
import idx from 'idx';

const COOKIE_EXPIRES = "2100-12-12";

export const HOMEPAGE_EXP_ID = "6RNU2IVBSbWLXhT0ztkVWg";

/* List of hard-coded experiments running.
   Each one is a dict with the following keys:
   - id: ID of the experiment as seen in Google Optimize dashboard.
   - variations: list of variation probabilities. E.g. [25, 25, 50] would allocate 25% of
     the traffic to variation 0 (original), 25% to variation 1 and 50% to variation 2. */
const HARDCODED_EXPERIMENTS = [
  { id: HOMEPAGE_EXP_ID, variations: [20, 0, 20, 20, 0, 20, 20] }
];

/* assign a random variation taking into account the variation probabilities */
export const assignVariation = (exp) => {
  const randomInt = random(1, 100);
  let acc = 0;
  for (let idx = 0; idx < exp.variations.length; idx++) {
    acc += exp.variations[idx];
    if (randomInt <= acc) {
      return idx;
    }
  }
  return 0;
}

/* format experiments retrieved from the API so that they match the
   shape of `HARDCODED_EXPERIMENTS` */
const formatAPIExperiments = (experiments=[]) => {
  return experiments.map(exp => ({
    id: exp.external_id,
    variations: concat([exp.original_weight*100], exp.variations.map(v => v.weight*100))
  }));
}

/* assign a variation for each of the running experiments if not already
   and return all assigned variations */
export const setResponseCookies = (req, res, pageBlockExperiments, pageExperiments) => {
  const variations = {};

  const allExperiments = concat(
    HARDCODED_EXPERIMENTS, formatAPIExperiments(pageBlockExperiments),
    formatAPIExperiments(pageExperiments)
  );

  allExperiments.forEach(exp => {
    let variation = req.cookies[exp.id];

    if (!variation) {
      variation = assignVariation(exp);

      res.cookie(exp.id, variation, {
        path: '/',
        expires: moment(COOKIE_EXPIRES).toDate()
      });
    }

    variations[exp.id] = parseInt(variation);
  });

  return variations;
}

/* get variation for a given experiment by looking at (in this order):
   - variations stored in `server` ducks state (server-side)
   - cookies stored in the browser (client-side) */
export const getVariation = (experimentId, state) => {
  return (
    idx(state, _ => _.server.optimizeVariations[experimentId]) ||
    parseInt(cookie.load(experimentId)) ||
    0
  );
}

export const activateExperiment = (experimentId, variationId) => {
  window.optimizeExperiments = window.optimizeExperiments || [];

  /* ignore already activated experiment */
  if (window.optimizeExperiments.find(e => e.id === experimentId)) {
    return;
  }

  window.optimizeExperiments.push({ id: experimentId, variant: variationId });

  if (typeof gtag !== 'undefined') {
    gtag("config", "UA-189008-2", { experiments: window.optimizeExperiments });
  } else {
    console.log(`Optimize experiments: ${window.optimizeExperiments}`)
  }
}
